<template>
  <!--
      作者：luoyiming
      时间：2019-06-04
      描述：插件中心-优惠券-领取记录
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户">
          <el-input v-model="formInline.user_name" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="优惠券">
          <el-input v-model="formInline.name" placeholder="请输入优惠券名称"></el-input>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="formInline.card_no" placeholder="请输入卡号"></el-input>
        </el-form-item>
        <el-form-item label="核销状态">
          <el-select v-model="formInline.is_veri" placeholder="请选择核销状态" style="width: 108px;">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已核销" :value="1"></el-option>
            <el-option label="未核销" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销人">
          <el-input v-model="formInline.veri_user_name" placeholder="请输入核销人"></el-input>
        </el-form-item>
        <el-form-item label="核销时间">
          <el-date-picker
            v-model="formInline.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <!-- 核销信息 -->
            <el-table-column prop="veri_coupon_id" label="核销ID" width="80"></el-table-column>
            <el-table-column prop="is_veri" label="核销状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.is_veri == 1" type="success" size="small">已核销</el-tag>
                <el-tag v-else type="info" size="small">未核销</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="veri_time" label="核销时间" width="150">
              <template slot-scope="scope">
                {{ formatTime(scope.row.veri_time) }}
              </template>
            </el-table-column>
            <el-table-column prop="veri_user_id" label="核销人ID" width="90"></el-table-column>
            <el-table-column prop="veriUser.nickName" label="核销人" width="100">
              <template slot-scope="scope">
                {{ scope.row.veriUser && scope.row.veriUser.nickName ? scope.row.veriUser.nickName : '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="120"></el-table-column>
            
            <!-- 用户信息 -->
            <el-table-column prop="user_id" label="用户ID" width="80"></el-table-column>
            <el-table-column prop="user.nickName" label="用户名" width="120">
              <template slot-scope="scope">
                {{ scope.row.user && scope.row.user.nickName ? scope.row.user.nickName : '--' }}
              </template>
            </el-table-column>
            
            <!-- 优惠券基本信息 -->
            <el-table-column prop="coupon.name" label="优惠券名称" width="180">
              <template slot-scope="scope">
                <div class="coupon-name">
                  {{ scope.row.coupon && scope.row.coupon.name ? scope.row.coupon.name : '--' }}
                </div>
                <div class="coupon-type" :style="{ color: getColorStyle(scope.row.coupon && scope.row.coupon.color ? scope.row.coupon.color.value : null) }">
                  {{ scope.row.coupon && scope.row.coupon.coupon_type && scope.row.coupon.coupon_type.text ? scope.row.coupon.coupon_type.text : '--' }}
                </div>
              </template>
            </el-table-column>
            
            <el-table-column prop="coupon.coupon_type" label="优惠类型" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.coupon && scope.row.coupon.coupon_type && scope.row.coupon.coupon_type.value == 10">
                  <span>满减券</span>
                  <div class="discount-info">减 {{ scope.row.coupon && scope.row.coupon.reduce_price ? scope.row.coupon.reduce_price : '0.00' }} 元</div>
                </div>
                <div v-else-if="scope.row.coupon && scope.row.coupon.coupon_type && scope.row.coupon.coupon_type.value == 20">
                  <span>折扣券</span>
                  <div class="discount-info">{{ scope.row.coupon && scope.row.coupon.discount ? scope.row.coupon.discount : '0' }} 折</div>
                </div>
                <div v-else>
                  <span>{{ scope.row.coupon && scope.row.coupon.coupon_type && scope.row.coupon.coupon_type.text ? scope.row.coupon.coupon_type.text : '--' }}</span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column prop="coupon.min_price" label="最低消费" width="100">
              <template slot-scope="scope">
                {{ scope.row.coupon && scope.row.coupon.min_price ? scope.row.coupon.min_price : '0.00' }}
              </template>
            </el-table-column>
            
            <!-- 有效期 -->
            <el-table-column prop="coupon.expire_type" label="有效期" width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.coupon && scope.row.coupon.expire_type == 10">
                  <div>领取后生效</div>
                  <div class="expire-info">{{ scope.row.coupon && scope.row.coupon.expire_day ? scope.row.coupon.expire_day : '0' }} 天有效</div>
                </div>
                <div v-else-if="scope.row.coupon && scope.row.coupon.expire_type == 20">
                  <div class="expire-range">
                    {{ scope.row.coupon && scope.row.coupon.start_time && scope.row.coupon.start_time.text ? scope.row.coupon.start_time.text : '--' }}
                    <div>至</div>
                    {{ scope.row.coupon && scope.row.coupon.end_time && scope.row.coupon.end_time.text ? scope.row.coupon.end_time.text : '--' }}
                  </div>
                </div>
                <div v-else>
                  --
                </div>
              </template>
            </el-table-column>
            
            <!-- 使用状态 -->
            <el-table-column prop="coupon.is_use" label="使用状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.coupon && scope.row.coupon.is_use == 1" type="danger" size="small">已使用</el-tag>
                <el-tag v-else-if="scope.row.coupon && scope.row.coupon.is_use == 0" type="success" size="small">未使用</el-tag>
                <span v-else>--</span>
              </template>
            </el-table-column>
            
            <el-table-column prop="coupon.is_expire" label="过期状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.coupon && scope.row.coupon.is_expire == 1" type="warning" size="small">已过期</el-tag>
                <el-tag v-else-if="scope.row.coupon && scope.row.coupon.is_expire == 0" type="success" size="small">未过期</el-tag>
                <span v-else>--</span>
              </template>
            </el-table-column>
            
            <!-- 创建时间 -->
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time || '--' }}
              </template>
            </el-table-column>
            
            <!-- 优惠券详情 -->
            <el-table-column prop="coupon.detail" label="优惠券详情" width="250">
              <template slot-scope="scope">
                <div class="coupon-detail">
                  <div v-if="scope.row.coupon">
                    <div>适用范围: {{ getApplyRangeText(scope.row.coupon.apply_range) }}</div>
                    <div v-if="scope.row.coupon.card_no">卡号: {{ scope.row.coupon.card_no }}</div>
                    <div v-if="scope.row.coupon.price && parseFloat(scope.row.coupon.price) > 0">卡余额: {{ scope.row.coupon.price }}</div>
                    <div v-if="scope.row.coupon.usage_count">剩余次数: {{ scope.row.coupon.usage_count }}</div>
                    <div v-if="scope.row.coupon.total_money && parseFloat(scope.row.coupon.total_money) > 0">总金额: {{ scope.row.coupon.total_money }}</div>
                    <div v-if="scope.row.coupon.recharge_money && parseFloat(scope.row.coupon.recharge_money) > 0">充值金额: {{ scope.row.coupon.recharge_money }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <!-- 操作列 -->
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button 
                  v-if="scope.row.is_veri == 0 && scope.row.coupon && scope.row.coupon.is_use == 0 && scope.row.coupon && scope.row.coupon.is_expire == 0"
                  type="primary" 
                  size="small"
                  @click="handleVerify(scope.row)"
                >
                  核销
                </el-button>
                <el-button 
                  type="info" 
                  size="small"
                  @click="showDetail(scope.row)"
                >
                  详情
                </el-button>
                <!-- <el-button 
                  v-if="scope.row.is_veri == 1"
                  type="warning" 
                  size="small"
                  @click="cancelVerify(scope.row)"
                >
                  撤销核销
                </el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange" 
          background 
          :current-page="formInline.page"
          :page-size="formInline.list_rows" 
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!-- 核销详情弹窗 -->
    <el-dialog 
      title="核销详情" 
      :visible.sync="detailDialogVisible" 
      width="50%"
      :before-close="closeDetailDialog"
    >
      <el-form v-if="currentDetail" label-width="120px" size="small">
        <el-form-item label="核销ID：">
          <span>{{ currentDetail.veri_coupon_id }}</span>
        </el-form-item>
        <el-form-item label="核销状态：">
          <el-tag v-if="currentDetail.is_veri == 1" type="success">已核销</el-tag>
          <el-tag v-else type="info">未核销</el-tag>
        </el-form-item>
        <el-form-item label="核销时间：">
          <span>{{ formatTime(currentDetail.veri_time) }}</span>
        </el-form-item>
        <el-form-item label="核销人ID：">
          <span>{{ currentDetail.veri_user_id }}</span>
        </el-form-item>
        <el-form-item label="核销人：">
          <span>{{ currentDetail.veriUser && currentDetail.veriUser.nickName ? currentDetail.veriUser.nickName : '--' }}</span>
        </el-form-item>
        <el-form-item label="核销门店ID：">
          <span>{{ currentDetail.veri_supply_id || '--' }}</span>
        </el-form-item>
        <el-form-item label="备注：">
          <span>{{ currentDetail.remark || '--' }}</span>
        </el-form-item>
        
        <el-divider>用户信息</el-divider>
        
        <el-form-item label="用户ID：">
          <span>{{ currentDetail.user_id }}</span>
        </el-form-item>
        <el-form-item label="用户名：">
          <span>{{ currentDetail.user && currentDetail.user.nickName ? currentDetail.user.nickName : '--' }}</span>
        </el-form-item>
        <el-form-item label="手机号：">
          <span>{{ currentDetail.user && currentDetail.user.mobile ? currentDetail.user.mobile : '--' }}</span>
        </el-form-item>
        
        <el-divider>优惠券信息</el-divider>
        
        <el-form-item label="优惠券名称：">
          <span>{{ currentDetail.coupon && currentDetail.coupon.name ? currentDetail.coupon.name : '--' }}</span>
        </el-form-item>
        <el-form-item label="优惠券类型：">
          <span :style="{ color: getColorStyle(currentDetail.coupon && currentDetail.coupon.color ? currentDetail.coupon.color.value : null) }">
            {{ currentDetail.coupon && currentDetail.coupon.coupon_type && currentDetail.coupon.coupon_type.text ? currentDetail.coupon.coupon_type.text : '--' }}
          </span>
        </el-form-item>
        <el-form-item label="优惠方式：">
          <span v-if="currentDetail.coupon && currentDetail.coupon.coupon_type && currentDetail.coupon.coupon_type.value == 10">
            满减券 - 减 {{ currentDetail.coupon && currentDetail.coupon.reduce_price ? currentDetail.coupon.reduce_price : '0.00' }} 元
          </span>
          <span v-else-if="currentDetail.coupon && currentDetail.coupon.coupon_type && currentDetail.coupon.coupon_type.value == 20">
            折扣券 - {{ currentDetail.coupon && currentDetail.coupon.discount ? currentDetail.coupon.discount : '0' }} 折
          </span>
          <span v-else>
            {{ currentDetail.coupon && currentDetail.coupon.coupon_type && currentDetail.coupon.coupon_type.text ? currentDetail.coupon.coupon_type.text : '--' }}
          </span>
        </el-form-item>
        <el-form-item label="最低消费：">
          <span>{{ currentDetail.coupon && currentDetail.coupon.min_price ? currentDetail.coupon.min_price : '0.00' }}</span>
        </el-form-item>
        <el-form-item label="有效期：">
          <span v-if="currentDetail.coupon && currentDetail.coupon.expire_type == 10">
            领取后 {{ currentDetail.coupon && currentDetail.coupon.expire_day ? currentDetail.coupon.expire_day : '0' }} 天有效
          </span>
          <span v-else-if="currentDetail.coupon && currentDetail.coupon.expire_type == 20">
            {{ currentDetail.coupon && currentDetail.coupon.start_time && currentDetail.coupon.start_time.text ? currentDetail.coupon.start_time.text : '--' }} 至 {{ currentDetail.coupon && currentDetail.coupon.end_time && currentDetail.coupon.end_time.text ? currentDetail.coupon.end_time.text : '--' }}
          </span>
          <span v-else>--</span>
        </el-form-item>
        <!-- <el-form-item label="使用状态：">
          <span v-if="currentDetail.coupon && currentDetail.coupon.is_use == 1">已使用</span>
          <span v-else-if="currentDetail.coupon && currentDetail.coupon.is_use == 0">未使用</span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="过期状态：">
          <span v-if="currentDetail.coupon && currentDetail.coupon.is_expire == 1">已过期</span>
          <span v-else-if="currentDetail.coupon && currentDetail.coupon.is_expire == 0">未过期</span>
          <span v-else>--</span>
        </el-form-item> -->
        <el-form-item label="创建时间：">
          <span>{{ currentDetail.create_time || '--' }}</span>
        </el-form-item>
        <el-form-item label="卡号：">
          <span>{{ currentDetail.coupon && currentDetail.coupon.card_no ? currentDetail.coupon.card_no : '--' }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CouponApi from '@/api/coupon.js';
import qs from 'qs';

export default {
  data() {
    return {
      formInline: {
        user_name: '',
        name: '',
        card_no: '',
        is_veri: -1,
        veri_user_name: '',
        dateRange: [],
        list_rows: 20,
        page: 1,
      },
      form: {},
      tableData: [],
      totalDataNumber: 0,
      loading: true,
      detailDialogVisible: false,
      currentDetail: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*获取列表*/
    getData() {
      this.loading = true;
      
      // 处理日期范围
      const params = Object.assign({}, this.formInline);
      if (params.dateRange && params.dateRange.length === 2) {
        params.start_time = params.dateRange[0];
        params.end_time = params.dateRange[1];
        delete params.dateRange;
      }
      
      CouponApi.hxList(params, true)
        .then(data => {
          this.loading = false;
          if (data.code === 1) {
            // 根据新的接口数据结构调整
            this.tableData = data.data.list || data.data || [];
            // 从分页数据中获取总数
            this.totalDataNumber = data.data.total || 0;
          } else {
            this.$message.error(data.msg || '获取数据失败');
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('获取数据失败:', error);
          this.$message.error('网络错误，请重试');
        });
    },
    
    /*搜索查询*/
    onSubmit() {
      this.formInline.page = 1;
      this.getData();
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.getData();
    },
    
    /*每页多少条*/
    handleSizeChange(val) {
      this.formInline.list_rows = val;
      this.formInline.page = 1;
      this.getData();
    },
    
    /*格式化时间戳*/
    formatTime(timestamp) {
      if (!timestamp) return '--';
      try {
        // 如果时间戳是字符串，先转为数字
        const time = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
        const date = new Date(time * 1000);
        return date.toLocaleString();
      } catch (error) {
        return '--';
      }
    },
    
    /*获取适用范围文本*/
    getApplyRangeText(range) {
      if (range === 10) return '全部商品';
      if (range === 20) return '指定商品';
      return '--';
    },
    
    /*获取颜色样式*/
    getColorStyle(colorValue) {
      if (!colorValue) return '#666';
      
      const colors = {
        10: '#1890ff', // 蓝色
        20: '#ff4d4f', // 红色
        30: '#722ed1', // 紫色
        40: '#faad14', // 黄色
        60: '#52c41a', // 绿色
      };
      return colors[colorValue] || '#666';
    },
    
    /*显示详情*/
    showDetail(row) {
      this.currentDetail = row;
      this.detailDialogVisible = true;
    },
    
    /*关闭详情弹窗*/
    closeDetailDialog() {
      this.detailDialogVisible = false;
      this.currentDetail = null;
    },
    
    /*核销操作*/
    handleVerify(row) {
      let couponName = '该优惠券';
      if (row.coupon && row.coupon.name) {
        couponName = row.coupon.name;
      }
      
      this.$confirm(`确定要核销优惠券 "${couponName}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        CouponApi.verifyCoupon({
          user_coupon_id: row.user_coupon_id,
          veri_user_id: this.$store.state.user.user_id,
          remark: '系统核销'
        }, true).then(data => {
          this.loading = false;
          if (data.code === 1) {
            this.$message.success('核销成功');
            this.getData();
          } else {
            this.$message.error(data.msg || '核销失败');
          }
        }).catch(error => {
          this.loading = false;
          this.$message.error('核销失败');
        });
      }).catch(() => {
        // 取消操作
      });
    },
    
    /*撤销核销*/
    cancelVerify(row) {
      let couponName = '该优惠券';
      if (row.coupon && row.coupon.name) {
        couponName = row.coupon.name;
      }
      
      this.$confirm(`确定要撤销核销优惠券 "${couponName}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        CouponApi.cancelVerify({
          veri_coupon_id: row.veri_coupon_id
        }, true).then(data => {
          this.loading = false;
          if (data.code === 1) {
            this.$message.success('撤销成功');
            this.getData();
          } else {
            this.$message.error(data.msg || '撤销失败');
          }
        }).catch(error => {
          this.loading = false;
          this.$message.error('撤销失败');
        });
      }).catch(() => {
        // 取消操作
      });
    },
    
    /*导出功能*/
    onExport() {
      // 处理日期范围参数
      const params = Object.assign({}, this.formInline);
      if (params.dateRange && params.dateRange.length === 2) {
        params.start_time = params.dateRange[0];
        params.end_time = params.dateRange[1];
        delete params.dateRange;
      }
      
      // 删除分页参数
      delete params.page;
      delete params.list_rows;
      
      // 构建导出URL
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let exportUrl = baseUrl + '/index.php/shop/plus.coupon.coupon/hxExport?' + qs.stringify(params);
      
      // 打开导出链接
      window.open(exportUrl, '_blank');
      
      // 或者使用 location.href（会替换当前页面）
      // window.location.href = exportUrl;
      
      this.$message.success('导出请求已发送，请稍候...');
    },
    
    /*如果需要先请求接口生成文件再下载，可以使用下面的方法*/
    onExportV2() {
      this.loading = true;
      
      // 处理日期范围参数
      const params = Object.assign({}, this.formInline);
      if (params.dateRange && params.dateRange.length === 2) {
        params.start_time = params.dateRange[0];
        params.end_time = params.dateRange[1];
        delete params.dateRange;
      }
      
      // 删除分页参数
      delete params.page;
      delete params.list_rows;
      
      // 调用导出接口
      CouponApi.hxExport(params, true)
        .then(response => {
          this.loading = false;
          if (response.code === 1) {
            // 如果有文件URL，直接下载
            if (response.data && response.data.url) {
              window.open(response.data.url, '_blank');
              this.$message.success('导出成功');
            } else {
              // 如果没有返回URL，尝试使用blob下载
              this.downloadFile(response);
            }
          } else {
            this.$message.error(response.msg || '导出失败');
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('导出失败');
        });
    },
    
    /*使用Blob下载文件*/
    downloadFile(response) {
      try {
        // 创建Blob对象
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
        
        // 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        // 设置文件名
        const fileName = `核销记录_${new Date().toLocaleDateString().replace(/\//g, '-')}.xlsx`;
        link.setAttribute('download', fileName);
        
        // 触发下载
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // 释放URL对象
        window.URL.revokeObjectURL(downloadUrl);
        
        this.$message.success('导出成功');
      } catch (error) {
        console.error('下载文件失败:', error);
        this.$message.error('下载文件失败');
      }
    },
  }
};
</script>

<style scoped>
.coupon-name {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
}

.coupon-type {
  font-size: 12px;
  font-weight: bold;
}

.discount-info {
  font-size: 12px;
  color: #ff6b6b;
  margin-top: 4px;
}

.expire-info {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.expire-range {
  font-size: 12px;
  line-height: 1.4;
}

.coupon-detail {
  font-size: 12px;
  line-height: 1.6;
  color: #666;
}

.coupon-detail div {
  margin-bottom: 2px;
}

/* 表格样式优化 */
.el-table .cell {
  line-height: 1.6;
}

/* 操作按钮间距 */
.el-table .el-button {
  margin-right: 5px;
}

.el-table .el-button:last-child {
  margin-right: 0;
}

/* 导出按钮样式 */
.el-button--success {
  background-color: #67c23a;
  border-color: #67c23a;
}

.el-button--success:hover {
  background-color: #5daf34;
  border-color: #5daf34;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/Hx.vue